<template>
     <div class="chart_main">
        <div ref="mychart" style="width:50%;height: 100%"></div>
        <div ref="mychart1" style="width:50%;height: 100%"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts/core'
import request from "@/utils/request"

export default{
    data(){
        return{
            option:{
                title : {
                    subtext: '今日',
                    x:'center',
                },
                tooltip : {
                    trigger: 'item',
                    formatter: "{b} : {c} ({d}%)"
                },
                legend: {
                    orient: 'horizontal', 
                    y: 'bottom',
                    data: ['客户取消计划','液厂取消计划']
                },
                series : [
                    {
                        type: 'pie',
                        radius : '55%',
                        // center: ['50%', '60%'],
                        data:[
                            {value:0, name:'客户取消计划'},
                            {value:0, name:'液厂取消计划'},
                        ],
                        label:{
                             normal:{
                                 position:'inner',
                                 show:true,
                                 formatter:'{c}',
                                 color:'#fff'
                             }
                        },
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            },
                             normal:{
                                color:(params)=>{
                                    let colorList=['#459af8', '#6cdefb']
                                    return colorList[params.dataIndex]
                                }
                            }
                        }
                    }
                ]
            },
             option1:{
                title : {
                    subtext: '明日',
                    x:'center'
                },
                tooltip : {
                    trigger: 'item',
                    formatter: "{b} : {c} ({d}%)"
                },
                legend: {
                    orient: 'horizontal', 
                    y: 'bottom',
                    data: ['客户取消计划','液厂取消计划']
                },
                series : [
                    {
                        type: 'pie',
                        radius : '55%',
                        // center: ['50%', '60%'],
                        data:[
                            {value:335, name:'客户取消计划'},
                            {value:310, name:'液厂取消计划'},
                        ],
                        label:{
                             normal:{
                                 position:'inner',
                                 show:true,
                                 formatter:'{c}',
                                 color:'#fff'
                             }
                        },
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            },
                            normal:{
                                color:(params)=>{
                                    let colorList=['#459af8', '#6cdefb']
                                    return colorList[params.dataIndex]
                                }
                            }
                        }
                    }
                ]
            }
        }
    },
     mounted(){
        this.init()
    },
    methods:{
        init(){
            request.get('index/invalid_count').then(res=>{
                if(res.code==200){
                    this.option.series[0].data[0].value=res.data.todayCancel
                    this.option.series[0].data[1].value=res.data.todayInvalid
                    this.option1.series[0].data[0].value=res.data.tomorrowCancel
                    this.option1.series[0].data[1].value=res.data.tomorrowInvalid
                    this.chart = echarts.init(this.$refs["mychart"]);
                    this.chart1 = echarts.init(this.$refs["mychart1"]);
                    this.chart.setOption(this.option);
                    this.chart1.setOption(this.option1);
                }else{
                    this.$message.error(res.msg)
                }
            })
            
        },
    }
}
    
   
  

</script>

<style scoped>
 .chart_main{
    display:flex;
    justify-content:space-between;
 }   
</style>
